import { render, staticRenderFns } from "./SidePanelDocSettings.vue?vue&type=template&id=3d1793a4&scoped=true&"
import script from "./SidePanelDocSettings.vue?vue&type=script&lang=js&"
export * from "./SidePanelDocSettings.vue?vue&type=script&lang=js&"
import style0 from "./SidePanelDocSettings.vue?vue&type=style&index=0&id=3d1793a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1793a4",
  null
  
)

export default component.exports